import { domainCheck } from 'utils/bom-dom-manipulation/is-subdomain';
import { GLOBALS } from './global-variables';

export const getDomain = (): string => {
  const domain = window.fromNext
    ? window.location.host
    : GLOBALS.appConfigs.domain;

  let mainDomain = 'springbuilder.site';
  let mainDomainNext = 'springbuilder.org';

  if (
    domain &&
    !domain.includes(mainDomain) &&
    !domain.includes(mainDomainNext)
  ) {
    const { pureDomain } = domainCheck(domain);

    if (pureDomain) {
      mainDomain = pureDomain;
      mainDomainNext = pureDomain;
    }
  }

  return !window.fromNext ? mainDomain : mainDomainNext;
};
